import React from 'react';
import type { RfqProject } from '../../types';
import { rfqStatusLabel, workTypeLabel } from '../../utils/vendorHelpers';

export interface VendorPortalProjectBadgesProps {
  project: RfqProject;
  needsQuote?: boolean;
  /** LCTF approved one of this supplier's quotes on this work type. */
  approved?: boolean;
  /** Staff rejected this supplier’s quote. */
  quoteRejected?: boolean;
  /** Another supplier won this work type (this org may never have quoted). */
  awardedElsewhere?: boolean;
  /** Portal badge when Hub phase is contracted. Not a comment gate. */
  underContract?: boolean;
}

function rfqStatusOpsClass(status: RfqProject['status']): string {
  switch (status) {
    case 'active':
    case 'invited':
      return 'ops-stat-active';
    case 'quoted':
      return 'ops-stat-done';
    default:
      return '';
  }
}

const VendorPortalProjectBadges: React.FC<VendorPortalProjectBadgesProps> = ({
  project,
  needsQuote = false,
  approved = false,
  quoteRejected = false,
  awardedElsewhere = false,
  underContract = false,
}) => (
  <div className="vp-project-badges">
    {approved ? (
      <span className="ops-stat ops-stat-done vp-project-badge-approved">Quote Approved</span>
    ) : quoteRejected ? (
      <span className="ops-stat vp-project-badge-rejected">Quote Rejected</span>
    ) : awardedElsewhere ? (
      <span className="ops-stat vp-project-badge-awarded-elsewhere">Awarded elsewhere</span>
    ) : (
      <span className={`ops-stat ${rfqStatusOpsClass(project.status)}`}>
        {rfqStatusLabel(project.status)}
      </span>
    )}
    {underContract && (
      <span className="ops-stat ops-stat-active vp-project-badge-contract">Under Contract</span>
    )}
    {project.workType && <span className="ops-stat">{workTypeLabel(project.workType)}</span>}
    {needsQuote && <span className="ops-stat ops-stat-overdue">Quote Needed</span>}
  </div>
);

export default VendorPortalProjectBadges;
